import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FlameIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME, recentBuyers } from '../data/salesContent';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % recentBuyers.length);
      }, 5500);
    };
    const first = setTimeout(show, 6000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto" aria-live="polite" data-id="element-47" data-mp="1gxvquglub50g">
      <AnimatePresence data-id="element-48" data-mp="16465yoc2wnc8">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 overflow-hidden rounded-lg border border-amber-400/40 bg-zinc-900 py-3 pl-4 pr-9 shadow-2xl shadow-black/70 sm:w-72" data-id="element-49" data-mp="117fqa246rtrc">
            <span className="absolute inset-y-0 left-0 w-1 bg-amber-400" aria-hidden="true" data-id="element-50" data-mp="x6c9ndebdtp2" />
            <span className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-amber-400 text-zinc-950" data-id="element-51" data-mp="s56hbgokg8g2">
              <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-52" data-mp="28imvezun4pk0" />
              <span className="absolute -right-0.5 -top-0.5 flex h-2.5 w-2.5" aria-hidden="true" data-id="element-53" data-mp="23m66w4jj496e">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-orange-500 opacity-75 motion-reduce:animate-none" data-id="element-54" data-mp="2apcpouelorfa" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full border-2 border-zinc-900 bg-orange-500" data-id="element-55" data-mp="2fpqzohzribfy" />
              </span>
            </span>
            <div className="min-w-0 text-xs leading-snug" data-id="element-56" data-mp="2pkspzh5rxjk4">
              <p className="font-bold uppercase tracking-wider text-amber-400" data-id="element-57" data-mp="1ry3dgddg3ok0">Compra reciente</p>
              <p className="mt-0.5 text-zinc-50" data-id="element-58" data-mp="1wx6cnh6qv0k2">
                <span className="font-semibold" data-id="element-59" data-mp="1wxy4qi14ug5l">{buyer.name}</span> de {buyer.city}, Argentina compró el{' '}
                <span className="font-semibold" data-id="element-60" data-mp="21uojn217b5pf">{PRODUCT_NAME}</span>
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded p-1 text-zinc-400 transition-colors duration-150 hover:text-zinc-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/50" data-id="element-61" data-mp="26oaow951c7b7">
              <XIcon className="h-3.5 w-3.5" data-id="element-62" data-mp="3rgew7z969k00" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}